import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PublicHeader from './PublicHeader';
import PublicFooter from './PublicFooter';

// Same six stages, order, and labels as the "Dock to Ledger" guide
// (public/guide/getting-started.html) and the Dashboard welcome card, so all three stay in sync.
const STAGES = [
  { icon: 'bi-signpost-2', title: 'Set up', body: 'Warehouses, quality grades, and users for your organization.' },
  { icon: 'bi-cart3', title: 'Purchase', body: 'Purchase orders, and weighbridge receipts if trucks are weighed in and out.' },
  { icon: 'bi-clipboard-check', title: 'Receive & grade', body: 'GRN puts material on your books; Quality Check grades it before it can be issued.' },
  { icon: 'bi-gear-wide-connected', title: 'Process', body: 'Bills of Materials and Work Orders turn raw material into finished goods.' },
  { icon: 'bi-graph-up-arrow', title: 'Sell', body: 'Sales orders and sale bills to your customers.' },
  { icon: 'bi-journal-text', title: 'Books', body: 'Every GRN, sale bill, and payment posts to the ledger automatically.' }
];

function Home() {
  return (
    <div className="d-flex flex-column min-vh-100">
      <PublicHeader />

      <Container className="py-5 flex-grow-1">
        <Row className="justify-content-center text-center mb-5">
          <Col lg={8}>
            <h1 className="mb-3">Run your manufacturing, processing or trading business on one system</h1>
            <p className="text-muted fs-5 mb-4">
              Purchase, weighbridge, quality grading, production, sales, and accounting -
              tracked end to end, from the truck at your gate to the ledger.
            </p>
            <div className="d-flex justify-content-center gap-2 flex-wrap">
              <Button as={Link} to="/login" variant="primary" size="lg">
                Sign In
              </Button>
              <Button as={Link} to="/register" variant="outline-primary" size="lg">
                Create an account
              </Button>
            </div>
          </Col>
        </Row>

        <Row className="justify-content-center mb-3">
          <Col lg={10}>
            <h2 className="text-center h4 mb-4">How it fits together</h2>
            <Row xs={1} md={2} lg={3} className="g-3">
              {STAGES.map((stage, i) => (
                <Col key={stage.title}>
                  <Card className="h-100">
                    <Card.Body>
                      <div className="d-flex align-items-center mb-2">
                        <i className={`bi ${stage.icon} fs-4 text-primary me-2`} />
                        <span className="text-muted small">{i + 1}</span>
                        <Card.Title className="mb-0 ms-2 h6">{stage.title}</Card.Title>
                      </div>
                      <Card.Text className="text-muted small mb-0">{stage.body}</Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>

        <Row className="justify-content-center text-center mt-4">
          <Col lg={8}>
            <a href="/guide/getting-started.html" target="_blank" rel="noopener noreferrer">
              <i className="bi bi-book me-1" />
              Read the Getting Started guide
            </a>
          </Col>
        </Row>
      </Container>
      <PublicFooter />
    </div>
  );
}

export default Home;
